const MANAGER = { OWN_PROCESS: 'Suravenir' } as const;

const CANCELABLE_PERIOD = {
  RETRACTATION: 14,
  RENONCIATION: 30,
} as const;

export { MANAGER, CANCELABLE_PERIOD };
